import { createFileRoute } from "@tanstack/react-router";
import { CohortPage } from "@/components/admin/CohortPage";

export const Route = createFileRoute("/admin/cohorts/spring-2027")({
  head: () => ({
    meta: [
      { title: "Spring 2027 Enrollments - WeLivdIt Admin" },
      { name: "description", content: "Spring 2027 student roster, outcomes, plans and revenue." },
      { property: "og:title", content: "Spring 2027 Enrollments - WeLivdIt Admin" },
      { property: "og:description", content: "Spring 2027 student roster, outcomes, plans and revenue." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <CohortPage cohort="spring_2027" path="/admin/cohorts/spring-2027" />,
});
